var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow2 = function SvgArrow2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.966.72.177.952c.328 1.764 1.135 2.686 1.927 3.198.815.527 1.703.674 2.261.709h1.618l-.06 1.365.138 1.187h-1.103a3.731 3.731 0 0 1-.446 0c-.506.025-1.451.153-2.327.673-.856.51-1.714 1.43-2.004 3.211l-.152.935-1.119-.12-.172-.033-1.27-.194.167-1c.247-1.484.798-2.616 1.495-3.472H.905V5.593h11.22c-.679-.852-1.227-1.975-1.505-3.451l-.181-.959 1.09-.233.165-.036L12.966.72Zm4.988 7.41h-.002Z"
  })));
};
export default SvgArrow2;